<template>
    <div id="">
        <report-header :title="headerTitle" backTo="false"></report-header>
        <button-next :title="buttonNextTitle"></button-next>
    </div>
</template>

<script>
import Header from '../../components/shared/report/Header'
import ButtonNext from '../../components/shared/report/ButtonNext'
export default {
    name: '',
    props:[],
    components:{
        'report-header': Header,
        'button-next': ButtonNext,
    },
    data: () => ({
        componentsData: {
            headerTitle: '',
            buttonNextTitle: '',
        }
    })
}
</script>

<style lang="scss" scoped>

</style>
